<template>
    <tr>
        <td>
            <button class="button is-primary" @click="saveItem">
                <i class="fas fa-save"></i>
            </button>
        </td>
        <td>
            <input class="input" v-model="name"/>
        </td>
        <td>
            <input class="input" v-model="remarks"/>
        </td>
        <td>
            <input class="input" v-model="amount"/>
        </td>
        <td></td>
    </tr>
</template>

<script>
    export default {
        computed: {
            name: {
                get() {
                   return this.$store.getters.getCustomInvoiceNewCostItem.name
                },
                set(value) {
                   this.$store.dispatch('changeCustomInvoiceNewCostItemFieldValue', { field: 'name', value: value})
                }
            },
            remarks: {
                get() {
                    return this.$store.getters.getCustomInvoiceNewCostItem.remarks
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceNewCostItemFieldValue', { field: 'remarks', value: value})
                }
            },
            amount: {
                get() {
                    return this.$store.getters.getCustomInvoiceNewCostItem.amount
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceNewCostItemFieldValue', { field: 'amount', value: value})
                }
            }
        },
        methods: {
            saveItem() {
                this.$store.dispatch('saveCustomInvoiceCostItem')
                this.$store.dispatch('changeCustomInvoiceTotalCostAmount')
                this.$store.dispatch('calculateCustomInvoice')
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceCostsTableCreateRow.vue